import { useState, useEffect, useRef } from "react";
import { apiCall } from '../utils/api';

const useSearch = (navigate, searchType) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const searchInputRef = useRef(null);
  const searchSuggestionsRef = useRef(null);

  useEffect(() => {
    if (!searchType) return; // no search if not on runbook page

    const handler = setTimeout(async () => {
      const trimmed = (searchTerm || "").trim();
      if (trimmed.length > 2) {
        try {
          // MODULES - Commented out for future use
          // const endpoint = searchType === "runbook" ? "/search_runbooks" : "/search_modules";
          const endpoint = "/search_runbooks"; // Only runbook search now
          const data = await apiCall(`${endpoint}?query=${encodeURIComponent(trimmed)}`);
          
          // Handle different response formats
          let results = [];
          if (Array.isArray(data)) {
            // Direct array response
            results = data;
          } else if (data && Array.isArray(data.results)) {
            // Response with results property
            results = data.results;
          } else {
            console.warn("Unexpected search response format:", data);
            results = [];
          }
          
          setSuggestions(results.slice(0, 10));
        } catch (err) {
          console.error("Error fetching suggestions:", err);
          setSuggestions([]);
        }
      } else {
        setSuggestions([]);
      }
    }, 300);

    return () => clearTimeout(handler);
  }, [searchTerm, searchType]);

  const handleSearchChange = (event) => setSearchTerm(event.target.value || "");

  const handleSuggestionClick = (item) => {
    setSuggestions([]);

    if (searchType === "runbook") {
      navigate(`/view-runbook/${item["Runbook ID"]}`);
    } 
    // MODULES - Commented out for future use
    // else if (searchType === "module") {
    //   navigate(`/view-module/${item["Module ID"]}`);
    // }

    setSearchTerm("");
  };

  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchSuggestionsRef.current &&
        !searchSuggestionsRef.current.contains(event.target) &&
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target)
      ) {
        setSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return {
    searchTerm,
    suggestions,
    searchInputRef,
    searchSuggestionsRef,
    handleSearchChange,
    handleSuggestionClick,
  };
};

export default useSearch;



